'use server'

import { apiRequest, ApiResponse } from '../request'

export interface PlatformAccount {
    id: number
    name: string
    paymentProvider: string | null
    paymentAccountId: string | null
    paymentWalletId: string | null
    paymentAccountStatus: 'PENDING_KYC' | 'ACTIVE' | 'BLOCKED' | 'CLOSED' | null
    paymentBalanceCache: number
    paymentBalanceSyncAt: string | null
    isPlatformAccount: boolean
    hasApiKey: boolean
    asaasUrl: string
}

export interface UpdatePlatformCredentialsData {
    apiKey?: string
    accountId?: string
    walletId?: string
    asaasUrl?: string
}

const BASE = 'financial/payment-account'

export async function getPlatformAccount(): Promise<ApiResponse<PlatformAccount>> {
    return apiRequest<PlatformAccount>(`${BASE}/platform`, {})
}

export async function updatePlatformCredentials(
    data: UpdatePlatformCredentialsData,
): Promise<ApiResponse<any>> {
    return apiRequest<any>(`${BASE}/platform-credentials`, { data }, 'post')
}

export async function fetchPlatformAccountFromProvider(): Promise<
    ApiResponse<{ accountId: string | null; walletId: string | null }>
> {
    return apiRequest<{ accountId: string | null; walletId: string | null }>(
        `${BASE}/platform/fetch-from-provider`,
        {},
    )
}

export async function reconcilePlatformWebhook(): Promise<
    ApiResponse<{ action: 'created' | 'updated' | 'kept' | 'skipped'; reason?: string }>
> {
    return apiRequest<{ action: 'created' | 'updated' | 'kept' | 'skipped'; reason?: string }>(
        `${BASE}/platform/reconcile-webhook`,
        {},
        'post',
    )
}
